import { useEffect, useState } from "react";

function useMedia(maxWidth: number) {
  const [match, setMatch] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth < maxWidth : false
  );
  useEffect(() => {
    const onResize = () => setMatch(window.innerWidth < maxWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [maxWidth]);
  return match;
}

export const useIsMobile = () => useMedia(768);
export const useIsTablet = () => useMedia(1024);
